import {
  inject,
  InjectionKey,
  provide,
  readonly,
  ref,
  useContext,
} from '@nuxtjs/composition-api'
import { injectProductList } from './useProductList'
import { WebNode } from '~/types/webNode'
import {
  FilterFields,
  ListType,
  ProductListMode,
  ProductListOptions,
} from '~/types/product'

export const useProductCategory = () => {
  const { app } = useContext()
  const base = injectProductList()

  const category = ref<WebNode | null>(null)

  const initialize = async (url: string) => {
    await base.ensureOptions(async () => {
      category.value = await app.$api.webNode.getByUrl(url)
      if (!category.value) return null

      const option: ProductListOptions = {
        listType: ListType.Category,
        prefilters: [
          {
            field: FilterFields.WebNodeId,
            value: category.value.id,
          },
        ],
        webNodeMode: ProductListMode.Navigation,
        category: category.value,
      }
      return option
    })

    await base.loadProducts(true)
  }

  return {
    category: readonly(category),
    ...base,
    initialize,
  }
}

// provide productCategory
const ProductCategoryProviderKey: InjectionKey<
  ReturnType<typeof useProductCategory>
> = Symbol('Provider:ProductCategory')

export const provideProductCategory = () => {
  const result = useProductCategory()

  provide(ProductCategoryProviderKey, result)
}

// inject productCategory
export const injectProductCategory = () => {
  const result = inject(ProductCategoryProviderKey)
  if (!result) {
    throw new Error('product category provider not set')
  }

  return result
}
